import { useTranslation } from "react-i18next";
import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <section id="categories" className="w-full bg-background-50">
      <div className="mx-auto max-w-6xl px-4 md:px-6 py-14 md:py-20">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            {t("categories.title")}
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            {t("categories.subtitle")}
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-100 hover:border-primary-300 transition-all cursor-pointer"
            >
              <div className="relative h-32 md:h-36 overflow-hidden">
                <img
                  src={cat.image}
                  alt={`${t(cat.nameKey)} — USFans Spreadsheet category`}
                  title={`${t(cat.nameKey)} — USFans Spreadsheet`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex items-center gap-2 px-4 py-3">
                <span className="w-5 h-5 flex items-center justify-center text-accent-500">
                  <i className={`${cat.icon} text-base`}></i>
                </span>
                <span className="text-sm font-semibold text-foreground-800 whitespace-nowrap">
                  {t(cat.nameKey)}
                </span>
                <span className="ml-auto w-4 h-4 flex items-center justify-center text-foreground-400 opacity-0 group-hover:opacity-100 transition-opacity">
                  <i className="ri-arrow-right-up-line text-sm"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}